import * as ACTIONS from '../../actionTypes/priceMatrixActionTypes';

export default (state = {}, action) => {
  const { type, ...rest } = action;
  switch (type) {
    case ACTIONS.TOGGLE_ERROR_POPUP:
      return {
        ...state,
        ...rest,
      };
    default:
      return state;
  }
};